import React from "react";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {MapPage} from "./pages/map/MapPage";
import {SearchPage} from "./pages/search/SearchPage";
import {SearchResult} from "./pages/search/result/SearchResult";
import {AccountPage} from "./pages/account/AccountPage";
import {HomePage} from "./pages/home/HomePage";
import AccessController from "./services/AccessController";
import "@aws-amplify/ui-react/styles.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage/>
  },
  // Browsing is open to everyone. Individual actions that write data, or read
  // another member's contributions, prompt for sign-in where they are used.
  {
    path: "/map",
    element: <MapPage/>
  },
  {
    path: "/search/*",
    element: <SearchPage/>,
    children: [
      {
        path: ':parkId',
        element: <SearchResult/>
      }
    ]
  },
  // /account is the one page with nothing to show a signed-out visitor, so it
  // keeps the full sign-in wall.
  {
    path: "/*",
    element: <AccessController/>,
    children: [
      {
        path: 'account',
        element: <AccountPage/>
      },
    ]
  },
])

export const App = () => <RouterProvider router={router}/>


